import { ClientEventRow } from '@entities/clients';
import { CALLS_FILTER_CAN_CALL, CALLS_FILTER_NO_CALLS } from '../consts';
import { compareCalls } from './compareCalls';
import { CallsSortDirection, ClientSideFilters } from './types';

const matchesBrokersFilter =
  ({ selectedBrokersFilter }: ClientSideFilters) =>
  (row: ClientEventRow) => {
    if (!selectedBrokersFilter.length) {
      return true;
    }

    return row.brokers.some((name) => selectedBrokersFilter.includes(name));
  };

const matchesCallsFilter =
  ({ selectedCallsFilter }: ClientSideFilters) =>
  (row: ClientEventRow) => {
    if (selectedCallsFilter === CALLS_FILTER_CAN_CALL) {
      return row.calls === false;
    }

    if (selectedCallsFilter === CALLS_FILTER_NO_CALLS) {
      return row.calls === true;
    }

    return true;
  };

const matchesManagersFilter =
  ({ isInvitingManagersFilter, selectedAllManagersFilter, selectedInvitingManagersFilter }: ClientSideFilters) =>
  (row: ClientEventRow) => {
    if (!isInvitingManagersFilter && selectedAllManagersFilter.length) {
      return (
        selectedAllManagersFilter.includes(row.salesManager) || selectedAllManagersFilter.includes(row.invitingManager)
      );
    }

    if (isInvitingManagersFilter && selectedInvitingManagersFilter.length) {
      return selectedInvitingManagersFilter.includes(row.invitingManager);
    }

    return true;
  };

export const filterAndSortEventClientRows = (
  rows: ClientEventRow[],
  filters: ClientSideFilters,
  callsSortDirection: CallsSortDirection
): ClientEventRow[] => {
  const filtered = rows
    .filter(matchesBrokersFilter(filters))
    .filter(matchesCallsFilter(filters))
    .filter(matchesManagersFilter(filters));

  if (!callsSortDirection) {
    return filtered;
  }

  return [...filtered].sort((firstRow, secondRow) => {
    const comparison = compareCalls(firstRow.calls, secondRow.calls);

    return callsSortDirection === 'asc' ? comparison : -comparison;
  });
};
